export default __webpack_public_path__ + "static/media/img-29-mago.693954a8.jpg";